import {Location, NgClass} from "@angular/common";
import {Component, effect, inject, input, output, signal} from "@angular/core";
import {DataSubscriptionService} from "src/app/infrastructure/data-subscription.service";
import {ViewportService} from "src/app/infrastructure/viewport.service";
import {
  AnimalStatusBarComponent
} from "src/app/presentation/main-view/information-center/animals/animal-status-bar/animal-status-bar.component";
import {
  AnimalDetailsBarComponent
} from "src/app/presentation/main-view/information-center/animals/animal-details-bar/animal-details-bar.component";
import {
  AnimalProfilePictureComponent
} from "src/app/presentation/common/icons/animal-profile-picture/animal-profile-picture.component";
import {MainViewStore} from "src/app/presentation/main-view/main-view.store";
import {Animal} from "src/app/infrastructure/moovement-api/models/asset";
import {randomUuid} from "src/app/domain/util/uuid/uuid";
import {Router} from "@angular/router";

@Component({
  selector: 'app-animal-details-container',
  standalone: true,
  imports: [
    AnimalDetailsBarComponent,
    NgClass,
    AnimalStatusBarComponent,
    AnimalProfilePictureComponent
],
  templateUrl: './animal-details-container.component.html',
  styleUrl: './animal-details-container.component.css'
})
export class AnimalDetailsContainerComponent {

  animal = input<Animal>();
  pregnant = signal(false);

  partialHeight = input.required<boolean>();
  showLocator = input.required<boolean>();
  onClose = output();
  navigatedBack = output();

  profilePictureModalIsVisible = signal(false);

  private readonly mainViewStore = inject(MainViewStore);
  private readonly location = inject(Location);

  constructor(
    protected dataSubscriptionService: DataSubscriptionService,
    protected viewportService: ViewportService,
    private readonly router: Router
  ) {
    effect(() => {
      this.focus();
    });
  }

  private focus() {
    if (!this.showLocator()) return;

    const id = this.animal()?.id;
    if (!id) return;

    this.dataSubscriptionService.publish(id + '.focus', randomUuid());
  }

  //Todo: Delete?
  // showProfilePictureModal() {
  //   const profilePictureUrl = this.animal()?.profilePictureUrl;
  //   if (!profilePictureUrl) return;
  //
  //   this.profilePictureModalIsVisible.set(true);
  // }

  showProfilePictureModal() {
    this.router.navigate(['main/animal-details', this.animal()?.id, 'set-profile-picture'])
  }

  dismissProfilePictureModal() {
    this.profilePictureModalIsVisible.set(false);
  }

  back(): void {
    this.location.back();
    this.navigatedBack.emit();
  }

  close() {
    this.mainViewStore.hideChildComponent();
    this.onClose.emit();
  }
}
